import React from "react";

export default function NotFound() {
  return (
    <div style={{textAlign: 'center', margin: 'auto', paddingTop: '45px', color: '#333'}}>
      <h3>La página que está buscando no existe.</h3>
    </div>
  );
}